
import { Component, Vue } from 'vue-property-decorator';

import Trail from './Trail.vue'
import FormIcon from './journeyicons/FormIcon.vue'
import GavelIcon from './journeyicons/GavelIcon.vue'
import ClockEndCircle from './journeyicons/ClockEndCircle.vue'

import InstructionWindowFooter from '../components/InstructionWindowFooter.vue';
import PathSidebar from '../components/PathSidebar.vue';
import NoticeOfAppearanceRspToLeavePg from '../components/RspToLeave/NoticeOfAppearanceRspToLeavePg.vue';
import ReplyBookRspToLeavePg from '../components/RspToLeave/ReplyBookRspToLeavePg.vue';
import TheHearingRspToLeavePg from '../components/RspToLeave/TheHearingRspToLeavePg.vue';
import DecisionOnLeaveToAppealRspToLeavePg from '../components/RspToLeave/DecisionOnLeaveToAppealRspToLeavePg.vue';

import {activatePage, evaluateCompletedTrails, evaluatePageState} from '@/components/utils/TrailOperations'

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application")
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

@Component({
    components:{
        Trail,
        FormIcon,
        GavelIcon,
        ClockEndCircle,
        InstructionWindowFooter,
        PathSidebar,
        NoticeOfAppearanceRspToLeavePg,
        ReplyBookRspToLeavePg,
        TheHearingRspToLeavePg,
        DecisionOnLeaveToAppealRspToLeavePg
    }
})
export default class RespondToLeaveJourneyMap extends Vue {
    
    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    dataReady = false;
    completedTrail :boolean[] = []
    numOfPages = 0;
    currentStep = 0;
    pageState : {active:boolean; status:string; ready:boolean;}[] = []

    showWindow = false;
    windowTitle = '';
    pathTypes = [] as string[];
    pathHeights = [] as string[];    
    noticeOfAppearanceContent = false; 
    replyBookContent = false;
    theHearingContent = false;
    decisionOnLeaveToAppealContent = false;

    mounted(){
        //console.log('RSP To Leave')
        this.dataReady = false;

        this.currentStep = this.stPgNo.RSP_TO_LEAVE._StepNo;
        this.numOfPages = Object.keys(this.stPgNo.RSP_TO_LEAVE).length-1;
        this.getJourneyMapCurrentState();
        
        this.dataReady = true;
    }

    public completed(order, checked){
        
        activatePage(order, checked, this.currentStep)
        this.getJourneyMapCurrentState();
    }

    public getJourneyMapCurrentState(){
        this.completedTrail = evaluateCompletedTrails(this.numOfPages, this.currentStep);
        this.pageState = evaluatePageState(this.numOfPages, this.currentStep);
    }

    public displayWindow(contentType: string){

        this.noticeOfAppearanceContent = false; 
        this.replyBookContent = false;
        this.theHearingContent = false;
        this.decisionOnLeaveToAppealContent = false;

        if (contentType == "Notice of Appearance"){
            this.windowTitle = "Notice of Appearance";
            this.pathTypes = ["share"];
            this.pathHeights = ['28rem'];
            this.noticeOfAppearanceContent = true;
        } else if (contentType == "Reply Book"){
            this.windowTitle = "Hearing Documents: Reply Book";
            this.pathTypes = ["share"];
            this.pathHeights = ['12rem'];
            this.replyBookContent = true;
        } else if (contentType == "The Hearing"){
            this.windowTitle = "The Hearing";
            this.pathTypes = ["gavel"];
            this.pathHeights = ['0'];
            this.theHearingContent = true;
        } else if (contentType == "Decision on Leave to Appeal"){
            this.windowTitle = "Decision on Leave to Appeal";
            this.pathTypes = ["gavel"];
            this.pathHeights = ['0'];
            this.decisionOnLeaveToAppealContent = true;
        }       
        this.showWindow = true;
    }

}
